import { Link } from "react-router-dom";
import { ArrowRight, Users } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useLang } from "@/i18n";
import { getBedIcon, resolveRoom } from "@/data/rooms";

export default function RoomCard({ room, index, wide = false }) {
    const { lang, t } = useLang();
    const d = resolveRoom(room, lang);
    const BedIcon = getBedIcon(room);
    return (
        <Reveal delay={(index % 3) * 0.12} className={wide ? "md:col-span-2" : ""}>
            <article
                data-testid={`room-card-${room.slug}`}
                className={`group flex h-full flex-col overflow-hidden rounded-2xl bg-cream shadow-[0_8px_30px_rgba(45,51,25,0.06)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_20px_40px_rgba(45,51,25,0.12)] ${wide ? "md:flex-row" : ""}`}
            >
                <div className={`overflow-hidden ${wide ? "md:w-1/2" : ""}`}>
                    <img
                        src={room.photo}
                        alt={`${d.name} — ${d.beds}`}
                        loading="lazy"
                        decoding="async"
                        width="1200"
                        height="800"
                        data-testid={`room-card-image-${room.slug}`}
                        className={`w-full object-cover transition-transform duration-700 group-hover:scale-105 ${wide ? "aspect-[4/3] md:aspect-auto md:h-full" : "aspect-[4/3]"}`}
                    />
                </div>
                <div className={`flex flex-1 flex-col p-6 md:p-8 ${wide ? "md:w-1/2 md:justify-center" : ""}`}>
                    <p className="text-[11px] font-medium uppercase tracking-[0.24em] text-amber">{d.tagline}</p>
                    <h3 className="mt-2 font-display text-2xl font-medium tracking-tight text-ink md:text-[1.7rem]">
                        {d.name}
                    </h3>
                    <div className="mt-3 flex items-center gap-5 text-sm font-light text-ink-muted">
                        <span className="flex items-center gap-1.5">
                            <Users className="h-4 w-4 text-olive" strokeWidth={1.5} />
                            {d.capacity}
                        </span>
                        <span className="flex items-center gap-1.5">
                            <BedIcon className="h-4 w-4 text-olive" strokeWidth={1.5} />
                            {d.beds}
                        </span>
                    </div>
                    <Link
                        to={`/alojamientos/${room.slug}`}
                        data-testid={`room-card-cta-${room.slug}`}
                        className="mt-6 inline-flex w-fit items-center gap-2 rounded-full border border-olive px-6 py-2.5 text-sm font-medium text-olive transition-all duration-300 hover:gap-3 hover:bg-olive hover:text-cream"
                    >
                        {t.rooms.verMas}
                        <ArrowRight className="h-4 w-4" strokeWidth={1.5} />
                    </Link>
                </div>
            </article>
        </Reveal>
    );
}
